var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSek = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39067 10.7024H23.8977C23.1307 4.81455 18.0962 0.267578 11.9993 0.267578C11.1033 0.267578 10.2306 0.366625 9.39062 0.552813V10.7024H9.39067Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26085 10.7003V1.72461C2.96581 3.52245 0.607016 6.82016 0.101562 10.7003H6.26085V10.7003Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2608 13.834H0.101562C0.607016 17.7142 2.96581 21.0119 6.26085 22.8097L6.2608 13.834Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39062 13.834V23.9836C10.2306 24.1697 11.1033 24.2688 11.9993 24.2688C18.0962 24.2688 23.1307 19.7218 23.8977 13.834H9.39062V13.834Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSek);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SEK.b1a0af282047d706d4e1c1fe821b495f.svg";